import BaseModel from "../base/BaseModel.model";

export default class IndicatorValue extends BaseModel {

    public value: number | null = null;
    public indicatorId: number | null = null;

    constructor(){
        super();
        this.init();
    }

    
    init(){
        this.indicatorId = null;
    }
}